export const contentTranslations = {
    en: {
        start: "START",
        from: "from",
        slano: "Slano",
        pickUpPoint: "Pick up point",
        hotel: "Hotel Osmine",
        freeTime: "3 hours",
        freeTimeLabel: "free time",
        arrival: "ARRIVAL",
        in: "in",
        around: "around",
        price: "PRICE",
        perAdult: "per adult",
        childrenFree: "*Children up to",
        childrenFreeAge: "3",
        childrenFreeEnd: "years of age -",
        childrenFreeBold: "FREE",
        childrenDiscount: "*Children from",
        childrenDiscountAge: "3 to 12",
        childrenDiscountEnd: "years of age -",
        childrenDiscountBold: "50% DISCOUNT",
        included: "INCLUDED",
        drinks: "DRINKS",
        drinksDetail: "(homemade rakija, wine, water)",
        reservations: "RESERVATIONS & INFORMATIONS",
        weatherNote: "*The captain reserves the right to change the route in case of bad weather or other unfavorable conditions in ports to ensure the safety of the ship and passengers."
    },
    hr: {
        start: "POLAZAK",
        from: "iz",
        slano: "Slanog",
        pickUpPoint: "Ukrcaj",
        hotel: "Hotel Osmine",
        freeTime: "3 sata",
        freeTimeLabel: "slobodnog vremena",
        arrival: "POVRATAK",
        in: "u",
        around: "oko",
        price: "CIJENA",
        perAdult: "po odrasloj osobi",
        childrenFree: "*Djeca do",
        childrenFreeAge: "3",
        childrenFreeEnd: "godine -",
        childrenFreeBold: "BESPLATNO",
        childrenDiscount: "*Djeca od",
        childrenDiscountAge: "3 do 12",
        childrenDiscountEnd: "godina -",
        childrenDiscountBold: "50% POPUST",
        included: "UKLJUČENO",
        drinks: "PIĆE",
        drinksDetail: "(domaća rakija, vino, voda)",
        reservations: "REZERVACIJE I INFORMACIJE",
        weatherNote: "*Kapetan zadržava pravo promjene rute u slučaju lošeg vremena ili drugih nepovoljnih uvjeta u lukama radi osiguranja sigurnosti broda i putnika."
    },
    es: {
        start: "SALIDA",
        from: "desde",
        slano: "Slano",
        pickUpPoint: "Punto de recogida",
        hotel: "Hotel Osmine",
        freeTime: "3 horas",
        freeTimeLabel: "de tiempo libre",
        arrival: "LLEGADA",
        in: "a",
        around: "alrededor de las",
        price: "PRECIO",
        perAdult: "por adulto",
        childrenFree: "*Niños hasta",
        childrenFreeAge: "3",
        childrenFreeEnd: "años -",
        childrenFreeBold: "GRATIS",
        childrenDiscount: "*Niños de",
        childrenDiscountAge: "3 a 12",
        childrenDiscountEnd: "años -",
        childrenDiscountBold: "50% DESCUENTO",
        included: "INCLUIDO",
        drinks: "BEBIDAS",
        drinksDetail: "(rakija casera, vino, agua)",
        reservations: "RESERVAS E INFORMACIÓN",
        weatherNote: "*El capitán se reserva el derecho de cambiar la ruta en caso de mal tiempo u otras condiciones desfavorables en los puertos para garantizar la seguridad del barco y los pasajeros."
    },
    it: {
        start: "PARTENZA",
        from: "da",
        slano: "Slano",
        pickUpPoint: "Punto di raccolta",
        hotel: "Hotel Osmine",
        freeTime: "3 ore",
        freeTimeLabel: "di tempo libero",
        arrival: "ARRIVO",
        in: "a",
        around: "intorno alle",
        price: "PREZZO",
        perAdult: "per adulto",
        childrenFree: "*Bambini fino a",
        childrenFreeAge: "3",
        childrenFreeEnd: "anni -",
        childrenFreeBold: "GRATIS",
        childrenDiscount: "*Bambini da",
        childrenDiscountAge: "3 a 12",
        childrenDiscountEnd: "anni -",
        childrenDiscountBold: "SCONTO 50%",
        included: "INCLUSO",
        drinks: "BEVANDE",
        drinksDetail: "(rakija fatta in casa, vino, acqua)",
        reservations: "PRENOTAZIONI E INFORMAZIONI",
        weatherNote: "*Il capitano si riserva il diritto di modificare il percorso in caso di maltempo o altre condizioni sfavorevoli nei porti per garantire la sicurezza della nave e dei passeggeri."
    },
    pl: {
        start: "ODJAZD",
        from: "z",
        slano: "Slano",
        pickUpPoint: "Miejsce odbioru",
        hotel: "Hotel Osmine",
        freeTime: "3 godziny",
        freeTimeLabel: "wolnego czasu",
        arrival: "POWRÓT",
        in: "do",
        around: "około",
        price: "CENA",
        perAdult: "za osobę dorosłą",
        childrenFree: "*Dzieci do",
        childrenFreeAge: "3",
        childrenFreeEnd: "lat -",
        childrenFreeBold: "BEZPŁATNIE",
        childrenDiscount: "*Dzieci od",
        childrenDiscountAge: "3 do 12",
        childrenDiscountEnd: "lat -",
        childrenDiscountBold: "50% ZNIŻKI",
        included: "W CENIE",
        drinks: "NAPOJE",
        drinksDetail: "(domowa rakija, wino, woda)",
        reservations: "REZERWACJE I INFORMACJE",
        weatherNote: "*Kapitan zastrzega sobie prawo do zmiany trasy w przypadku złej pogody lub innych niekorzystnych warunków w portach w celu zapewnienia bezpieczeństwa statku i pasażerów."
    },
    fr: {
        start: "DÉPART",
        from: "de",
        slano: "Slano",
        pickUpPoint: "Point de ramassage",
        hotel: "Hôtel Osmine",
        freeTime: "3 heures",
        freeTimeLabel: "de temps libre",
        arrival: "ARRIVÉE",
        in: "à",
        around: "vers",
        price: "PRIX",
        perAdult: "par adulte",
        childrenFree: "*Enfants jusqu'à",
        childrenFreeAge: "3",
        childrenFreeEnd: "ans -",
        childrenFreeBold: "GRATUIT",
        childrenDiscount: "*Enfants de",
        childrenDiscountAge: "3 à 12",
        childrenDiscountEnd: "ans -",
        childrenDiscountBold: "50% DE RÉDUCTION",
        included: "INCLUS",
        drinks: "BOISSONS",
        drinksDetail: "(rakija maison, vin, eau)",
        reservations: "RÉSERVATIONS & INFORMATIONS",
        weatherNote: "*Le capitaine se réserve le droit de modifier l'itinéraire en cas de mauvais temps ou d'autres conditions défavorables dans les ports afin d'assurer la sécurité du navire et des passagers."
    },
    de: {
        start: "ABFAHRT",
        from: "von",
        slano: "Slano",
        pickUpPoint: "Abholpunkt",
        hotel: "Hotel Osmine",
        freeTime: "3 Stunden",
        freeTimeLabel: "Freizeit",
        arrival: "ANKUNFT",
        in: "in",
        around: "gegen",
        price: "PREIS",
        perAdult: "pro Erwachsener",
        childrenFree: "*Kinder bis",
        childrenFreeAge: "3",
        childrenFreeEnd: "Jahre -",
        childrenFreeBold: "KOSTENLOS",
        childrenDiscount: "*Kinder von",
        childrenDiscountAge: "3 bis 12",
        childrenDiscountEnd: "Jahren -",
        childrenDiscountBold: "50% RABATT",
        included: "INKLUSIVE",
        drinks: "GETRÄNKE",
        drinksDetail: "(hausgemachte Rakija, Wein, Wasser)",
        reservations: "RESERVIERUNGEN & INFORMATIONEN",
        weatherNote: "*Der Kapitän behält sich das Recht vor, die Route bei schlechtem Wetter oder anderen ungünstigen Bedingungen in den Häfen zu ändern, um die Sicherheit des Schiffes und der Passagiere zu gewährleisten."
    }
};